/**
 * The default ARIA label for the WeekNumber element.
 */
export var labelYearDropdown = function () {
    return 'Year: ';
};
//# sourceMappingURL=labelYearDropdown.js.map